import { render } from "./LandownerEstateUpdate.vue?vue&type=template&id=45a75f66&scoped=true&ts=true&lang=pug"
import script from "./LandownerEstateUpdate.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandownerEstateUpdate.vue?vue&type=script&lang=ts&setup=true"

import "./LandownerEstateUpdate.vue?vue&type=style&index=0&id=45a75f66&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a75f66"]])

export default __exports__